import {
  AbstractControl,
  FormArray,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export class CustomValidators {
  static requiredNonWhitespace(
    control: AbstractControl
  ): ValidationErrors | null {
    const val = control.value;
    if (val == null || val.toString().trim() === '') {
      return { required: true };
    }
    return null;
  }

  static optionalE164(control: AbstractControl): ValidationErrors | null {
    const val = control.value;
    return !val || /^\+?[1-9]\d{1,14}$/.test(val)
      ? null
      : { phoneNumber: true };
  }

  static optionalHttpUrl = (control: AbstractControl) => {
    const raw = control.value;
    if (raw === null || raw === undefined) return null;

    const val = raw.toString().trim();
    if (val === '') return { invalidUrl: true };

    const url = /^https?:\/\//i.test(val) ? val : 'http://' + val;

    try {
      const parsed = new URL(url);
      const isHttp = ['http:', 'https:'].includes(parsed.protocol);
      const hostname = parsed.hostname;

      const isLikelyDomain =
        hostname.includes('.') &&
        /[a-zA-Z]/.test(hostname) &&
        !hostname.startsWith('.') &&
        !hostname.endsWith('.');

      return isHttp && isLikelyDomain ? null : { invalidUrl: true };
    } catch {
      return { invalidUrl: true };
    }
  };
}
